/**
 * India's states and union territories, as a contact's State is picked (V36). Spelled as the
 * API's GST state table spells them, so a picked state and a GSTIN's state code compare equal
 * when deciding CGST + SGST against IGST.
 */
export const INDIAN_STATES = [
  'Andaman and Nicobar Islands',
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
] as const;

/** The firm's own state: new contacts and companies start in it (V37), so they are billed CGST + SGST. */
export const DEFAULT_STATE = 'Maharashtra';

/** `{label, value}` pairs for a type-to-search picker; clearing it leaves the state unset. */
export const INDIAN_STATE_OPTIONS: Array<{ label: string; value: string }> = INDIAN_STATES.map((s) => ({
  label: s,
  value: s,
}));
